<script>
    import { handleAsync } from "../../common/safe_promise";
    import firebase from "firebase/app";
    import { app } from "../../firebase";
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from "svelte";
    import DocEditor from "../DocEditor.svelte";
    const db = app.firestore();

    export let doc = null;
    export let form;
    export let path;
    export let uid = null;
    export let valid = false;
    export let deletable = true;

    $: docPath = (path.path
        ? `/${path.path}`
        : [path, uid].filter((it) => it).join("/")
    ).replace(/\/+/, "/");

    const handleSave = handleAsync(async ({ detail: { data, isNew } }) => {
        await db.doc(docPath).set({
            ...data,
            lastModified: firebase.firestore.FieldValue.serverTimestamp(),
            createdAt:
                doc.createdAt ||
                firebase.firestore.FieldValue.serverTimestamp(),
        });
        dispatch("save", { isNew });
        isNew = false;
    });

    const dispatch = createEventDispatcher();

    const handleDelete = handleAsync(async () => {
        await db.doc(docPath).delete();
        dispatch("delete");
    });
</script>

<DocEditor
    {doc}
    {form}
    bind:valid
    {deletable}
    on:save={handleSave}
    on:delete={handleDelete} />
